module.exports = __webpack_public_path__ + "static/media/kalkulator_landing.ab4e3537.jpg";